<template>
<v-col cols="12" md="6">
    <v-card class="mx-auto" tile>
        <v-card-title>{{ type }}s</v-card-title>


        <v-data-table
        :headers="headers"
        :items="filteredItems"
        disable-pagination
        :hide-default-footer="true"
        >
        <template v-slot:[`item.name`]="{ item }">
           <router-link :to="{ name: type + '-gallery' , params: { id: item[type].name.toLowerCase() }}">
                {{ item[type].name }}
            </router-link>       
        </template>

        <template v-slot:[`item.status`]="{ item }">
            <span v-if="item.is_admin"><strong>admin</strong></span><span v-else>member</span>
        </template>
        
        <template v-slot:[`item.actions`]="{ item }">
            <span v-if="item.is_admin"> 
                
                    <v-edit-dialog
                    :return-value.sync="item.name"
                    large
                    persistent
                    @save="save"
                    @cancel="cancel"
                    > 
                    <v-icon>$vuetify.icons.editoutline</v-icon>
                    <template v-slot:input>
                        <v-text-field
                        v-model="item[type].name"
                        :rules="[max25chars]"
                        label="Edit"
                        single-line
                        counter
                        ></v-text-field>
                    </template>
                    </v-edit-dialog>
                
            </span>
        </template>
        </v-data-table>
        <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
        {{ snackText }}

        <template v-slot:action="{ attrs }">
            <v-btn v-bind="attrs" text @click="snack = false">Close</v-btn>
        </template>
        </v-snackbar>
    </v-card>
    </v-col>
     
</template>

<script>
import { groupMixin } from '@/functions/mixins'

export default {
    name: "ProfileGroup",
    props: ['groups','type'],
    mixins: [groupMixin],
    data() {
        return {
            headers: [
                { text: "Name", align: "start", sortable: true, value: "name" },
                { text: "Status", align: "start", sortable: true, value: "status" },
                { text: "Actions", value: "actions", sortable: false },
            ],
            snack: false,
            snackColor: '',
            snackText: '',
            max25chars: v => v.length <= 25 || 'Input too long!',
        }
    },
    methods: {
        inObjectArray (needle, haystack) {
            var length = haystack.length;
            for(var i = 0; i < length; i++) {
                if(haystack[i].id == needle.id) return true;
            }
            return false;
        },
        save () {
            
            this.snack = true
            this.snackColor = 'success'
            this.snackText = 'Data saved'
        },
        cancel () {
            this.snack = true
            this.snackColor = 'error'
            this.snackText = 'Canceled'
        }
    }
}
</script>
